/* import __COLOCATED_TEMPLATE__ from './series-started-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();